module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a3-10-437b728804e1ad870824ed11e803b0c9.jpg";